import React from "react"
import { Row, Col } from "reactstrap"
import yoWave from '../../assets/images/theme-2025/yo_wave.svg'
import logoLightText from '../../assets/images/theme-2025/logoLightText.svg'
import bCorp from '../../assets/images/theme-2025/yo-footer/b-corp.svg'
import award1 from '../../assets/images/theme-2025/yo-footer/award1.svg'
import award2 from '../../assets/images/theme-2025/yo-footer/award2.svg'
import award3 from '../../assets/images/theme-2025/yo-footer/award3.svg'
import award4 from '../../assets/images/theme-2025/yo-footer/award4.svg'
import award5 from '../../assets/images/theme-2025/yo-footer/award5.svg'

const Footer = () => {
  return (
    <footer className="footer">
      <img src={yoWave} className="footer--wave"/>

      <div className="footer--content-wraper">
        <div className="footer--content">

          <Row className="mb-4 d-flex gap-4">
            <Col sm={12} md={12} lg={5}>
              <a target="__blank" href="https://yellow-octopus.com" className="clickable"><img src={logoLightText} height={85} /></a>
            </Col>
            <Col sm={12} md={12} lg={6} >
              <img src={bCorp} height={132} />
            </Col>
            {/* <Col sm={12} md={12} lg={8}></Col> */}
          </Row>

          <Row className="mb-4">
            <Col sm={6}>
              <div style={{ fontSize: 18, fontWeight: '500' }}>Contact Us</div>
              <a href="mailto:hello@yellow-octopus.com" className="email-link text-decoration-underline" style={{ fontSize: 16, color: "#fff", fontWeight: '500' }}>
                hello@yellow-octopus.com
              </a>
            </Col>
            <Col sm={6}></Col>
          </Row>

          <Row className="mb-4 border-top">
            <Col sm={12} lg={4}>
              <div className="address-text">
                Yellow Octopus Circular Solutions
                <br/>Unit 1 &amp; Unit 2 Teal Park, Cyan Close,
                <br/>Netherfield , Nottingham
                <br/>NG14 5JX, England
              </div>
            </Col>
        
            <Col sm={12} lg={4} className="d-flex gap-3 align-items-center">
              <img src={award1} height={26}/>
              <img src={award2} height={66}/>
              <img src={award3} height={66}/>
              <img src={award4} height={66}/>
              <img src={award5} height={22}/>
            </Col>

            <Col sm={12} lg={4}>
              <div className="address-text text-end">
                Yellow Octopus EU
                <br/>Gromadzka 5
                <br/>05-806 Sokolow, Poland
              </div>
            </Col>
          </Row>

          <Row className="border-top">
            <Col sm={6} className="d-flex gap-4">
              <a target="__blank" href="https://cdn.prod.website-files.com/672b3e43321ea21ff6cc6967/678a23140bcb32a4d1f0b8ac_Environmental-Policy.pdf"
                className="text-decoration-underline"
                style={{ fontSize: 13, color: "#fff", fontWeight: '500' }}
              >
                Quality Policy
              </a>
              <a target="__blank" href="https://cdn.prod.website-files.com/672b3e43321ea21ff6cc6967/676530d32306750adb3dddb5_Polityka%20s%CC%81rodowiskowa%2014001%20%20%20%2001%2012%202023.pdf"
                className="text-decoration-underline"
                style={{ fontSize: 13, color: "#fff", fontWeight: '500' }}
              >
                Environmental Policy
              </a>
              <a target="__blank" href="https://cdn.prod.website-files.com/672b3e43321ea21ff6cc6967/67e280e3f152c2f7391b972b_Code%20of%20Ethics%2002%2003%202023.pdf"
                className="text-decoration-underline"
                style={{ fontSize: 13, color: "#fff", fontWeight: '500' }}
              >
                Ethical Policy
              </a>
            </Col>
            <Col sm={6}></Col>
          </Row>
        </div>
      </div>
    </footer>
  )
}

export default Footer
